import { useMemo, useState } from "react";
import CustomTable from "./components/customTable/CustomTable";

export default function TableQarbalParvande({ rowData }) {
  const colDefs = useMemo(
    () => [
      {
        field: "height",
        headerName: "قد",
        width: 90,
      },
      {
        field: "weight",
        headerName: "وزن",
        width: 90,
      },
      {
        field: "BMI",
        headerName: "bmi",
        width: 110,
      },
      {
        field: "shepesh",
        headerName: "شپش",
        width: 110,
      },
      {
        field: "recvCulturePackage",
        headerName: "بسته فرهنگی",
        width: 125,
      },
      {
        field: "recvShampoo",
        headerName: "شامپو",
        width: 90,
      },
      {
        field: "description",
        headerName: "توضیحات",
        width: 200,
      },
    ],
    [],
  );

  return (
    <>
      <CustomTable rowData={rowData} columns={colDefs} needPagination={false} />
    </>
  );
}
